export const MuiSkeleton = {
  defaultProps: {
    // Remove backgroundColor
  },
  styleOverrides: {
    root: {
      backgroundColor: '#efefef',
    },
  },
  variants: [
    {
      props: {
        variant: 'rectangular',
      },
      style: {
        backgroundColor: '#efefef',
      },
    },
  ],
}
